'use client';

import dynamic from 'next/dynamic';

const GoogleReviews = dynamic(() => import('@/components/sections/google-reviews').then((mod) => mod.GoogleReviews), {
  ssr: false,
});

export function ClientGoogleReviews() {
  return <GoogleReviews />;
}
